module.exports = __webpack_public_path__ + "static/media/stats.573b2634.jpg";